import { Text, useMediaQuery, useStyleConfig } from '@chakra-ui/react';

const MobileAlert = ({}) => {

  const variant = 'wrapper';
  const headerStyle = useStyleConfig('Header',{variant});
  const isMobile = useMediaQuery('(max-width: 768px)',{ssr:false});
  if(isMobile[0]) {
    return (

      <Text  sx={{...headerStyle.mobileWarning}}>Heads up! This app is better on a desktop</Text>
    )
  } else {
    return null;
  }
}
export default MobileAlert;